import { ChangeEventHandler, FC, useState } from 'react'
import { usePostMeasurement } from '../generated/apiData'
import { isSuccess } from '../utils/api'
import { formatDateTimeLocal } from '../utils/formatDateTimeLocal'
import './AddItem.css'


const AddItem: FC = () => {
    const postResource = usePostMeasurement()

    const [value, setValue] = useState<number | undefined>()
    const [measured, setMeasured] = useState<string>(formatDateTimeLocal(new Date()))
    const [remarks, setRemarks] = useState<string>('')
    const [meal, setMeal] = useState<number>(0)
    const [timeDifference, setTimeDifference] = useState<number>(0)

    const onSubmit: React.FormEventHandler<HTMLFormElement> = event => {
        if (value && measured) {
            console.log({
                Value: value,
                Measured: measured,
                Remarks: remarks,
                Meal: meal,
                TimeDifference: timeDifference,
                idUsers: 0,
            })
            void postResource
                ?.perform(
                    {},
                    {
                        Value: value,
                        Measured: measured,
                        Remarks: remarks,
                        Meal: meal,
                        TimeDifference: timeDifference,
                        idUsers: 0,
                    },
                )
                .then(item => {
                    if (isSuccess(item)) {
                        setValue(undefined)
                        setMeasured(formatDateTimeLocal(new Date()))
                        setRemarks('')
                    }
                })
        }
        event.preventDefault()
    }

    const onChangeMeal: ChangeEventHandler<HTMLInputElement> = 
        ({target: {value}}) => {
            setMeal(+value)
            if (+value === 0) {
                setTimeDifference(0)
            } else {
                if (timeDifference === 0) {
                    setTimeDifference(1)
                }
            }
        }
    const onChangeTimeDifference: ChangeEventHandler<HTMLInputElement> = 
        ({target: {value}}) => {
            setTimeDifference(+value)
        }
    return (
        <form onSubmit={onSubmit}className='vertical'>
            <label>
                Waarde:
                <br />
                <input
                    type="number"
                    onChange={({target: {value}}) => {
                        setValue(+value)
                    }}
                    step="0.1"
                    value={value}
                />
            </label>
            <label>
                Wanneer:
                <br />
                <input
                    type="datetime-local"
                    onChange={({target: {value}}) => setMeasured(value)}
                    value={measured}
                />
            </label>
            <span className='vertical'>
                Maaltijd:
                <br />
                
                <label>
                    <input
                        type="radio"
                        onChange={onChangeMeal}
                        value={0}
                        name="meal"
                        checked={meal === 0}
                    />
                    Voor ontbijt
                </label>
                <label>
                    <input
                        type="radio"
                        onChange={onChangeMeal}
                        value={1}
                        name="meal"
                        checked={meal === 1}
                    />
                    Na ontbijt
                </label>
                <label>
                    <input
                        type="radio"
                        onChange={onChangeMeal}
                        value={2}
                        name="meal"
                        checked={meal === 2}
                    />
                    Na lunch
                </label>
                <label>
                    <input
                        type="radio"
                        onChange={onChangeMeal}
                        value={3}
                        name="meal"
                        checked={meal === 3}
                    />
                    Na avondeten
                </label>
            </span>
            {meal !== 0 && <span className='vertical'>
                Tijd verschil:
                <br />
                
                <label>
                    <input
                        type="radio"
                        onChange={onChangeTimeDifference}
                        value={1}
                        name="timeDifference"
                        checked={timeDifference === 1}
                    />
                    1 uur
                </label>
                <label>
                    <input
                        type="radio"
                        onChange={onChangeTimeDifference}
                        value={2}
                        name="timeDifference"
                        checked={timeDifference === 2}
                    />
                    2 uur
                </label>
            </span>}
            <label>
                Opmerking:
                <br />
                <textarea
                    onChange={({target: {value}}) => setRemarks(value)}
                    rows={5}
                    cols={50}
                    value={remarks}/>
            </label>
            <input
                type="submit"
                value="Voeg toe"
            />
        </form>
    )
}

export default AddItem
